/* Geral / Bibliotecas */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import "react-toggle/style.css";

/* Cores */

/* Métodos / Ações */
import { fetchComentarios, saveComentario } from "../../actions/comentarios";
import { clearErrors } from "../../actions/errors";
import { URL_API } from "../../actions/urls";
import objToQueryString from "../../helpers/objToQueryString";

/* Componentes */
import Error from "../Error";
import LoadingImage from "../LoadingImage";

/* Botões */
import ButtonWarning from "../Buttons/ButtonWarning";

/* Validação */
import { requiredField } from "../../validation/formValidation";
import { COLOR_WARNING } from "../../Colors";
import ButtonSuccess from "../Buttons/ButtonSuccess";

const MySwal = withReactContent(Swal);

class ComentarioForm extends Component {
  constructor() {
    super();

    this._isMounted = false;
    this.state = {
      lockedFields: false,
      page: 1,
    };
  }

  isTomador() {
    // tipo contrato nesse caso se refere a quem irá receber a mensagem, não a posição do usuário no contexto do contrato
    return this.props.tipoContrato === "terceiro";
  }

  handleSubmit(values, actions) {
    this.props.dispatch(
      saveComentario(
        values,
        actions,
        this.props.contrato,
        this.props.dados.documento
          ? this.props.dados.documento.idDocumento
          : null,
        this.props.dados.funcionario
          ? this.props.dados.funcionario.idFuncionario
          : null,
        this.props.dados.funcionario
          ? this.props.dados.funcionario.idFilialFuncionario
          : null,
      ),
    );
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.dispatch(
      fetchComentarios(
        this.props.contrato,
        this.props.dados.documento
          ? this.props.dados.documento.idDocumento
          : null,
        this.props.dados.funcionario
          ? this.props.dados.funcionario.idFuncionario
          : null,
        this.props.dados.funcionario
          ? this.props.dados.funcionario.idFilialFuncionario
          : null,
      ),
    );
  }

  commentsPaginate = () => {
    this.setState({ page: this.state.page + 1 }, () => {
      this.props.dispatch(
        fetchComentarios(
          this.props.contrato,
          this.props.dados.documento
            ? this.props.dados.documento.idDocumento
            : null,
          this.props.dados.funcionario
            ? this.props.dados.funcionario.idFuncionario
            : null,
          this.props.dados.funcionario
            ? this.props.dados.funcionario.idFilialFuncionario
            : null,
          this.state.page,
        ),
      );
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(nextProps) {
    if (nextProps.errors) {
      let show = false;
      if (Object.keys(nextProps.errors)?.length) {
        show = true;
      }
      if (show) {
        MySwal.fire({
          type: "error",
          title: nextProps.errors.message,
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 3000,
        });
        this.props.dispatch(clearErrors());
      }
    }
    if (nextProps.contrato !== this.props.contrato) {
      this.props.dispatch(
        fetchComentarios(
          nextProps.contrato,
          this.props.dados.documento
            ? this.props.dados.documento.idDocumento
            : null,
        ),
      );
    }
  }

  render() {
    if (this.props.error) {
      return <Error erro={this.props.error}></Error>;
    }

    if (this.props.loading) {
      return <LoadingImage></LoadingImage>;
    }

    return (
      <div className="pb-5">
        <div className="row mx-0 d-flex align-items-center justify-content-center">
          <div className="col-12 px-4">
            <div className="card">
              <div className="card-body pt-2 pb-0">
                {this.props.loading && <LoadingImage></LoadingImage>}

                {!this.props.loading && this.props.total > 0 && (
                  <button
                    className="btn-link"
                    style={{ textDecoration: "underline", color: "#f15923" }}
                    onClick={this.commentsPaginate}
                    type="submit"
                  >
                    <u>+{this.props.total} comentários</u>
                  </button>
                )}
                {!this.props.loading && this.props.comentarios?.length ? (
                  this.props.comentarios.reverse()?.map((comentario, index) => (
                    <div className="box-comment py-4" key={index}>
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <p>
                            {comentario.interno === 1 && (
                              <span
                                title="Comentário interno"
                                style={{ color: COLOR_WARNING }}
                              >
                                <FontAwesomeIcon icon={"lock"} />
                                &nbsp;
                              </span>
                            )}
                            <strong>
                              {comentario.usuario.toUpperCase()}
                            </strong>{" "}
                            disse:
                          </p>
                        </div>
                        <div className="col-12 col-md-6 text-right">
                          <p>
                            {moment(comentario.dataHora.date).format(
                              "DD/MM/YYYY [ás] HH:mm",
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <p className="m-0">
                            {comentario.mensagem
                              .toUpperCase()
                              .split("\n")
                              .map((linha) => (
                                <>
                                  {linha}
                                  <br />
                                </>
                              ))}
                          </p>
                          {comentario.idAnexoRecado !== null && (
                            <div className="mt-2">
                              <a
                                href={
                                  URL_API +
                                  "comentarios/anexo" +
                                  objToQueryString({
                                    token: localStorage.getItem("jwtToken"),
                                    idAnexoRecado: comentario.idAnexoRecado,
                                  })
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none" }}
                              >
                                <small
                                  className="badge-pill badge-danger py-1 px-2 mx-1 font-weight-bold text-uppercase"
                                  style={{
                                    background: "#f15923",
                                    display: "inline-block",
                                  }}
                                >
                                  <FontAwesomeIcon icon={"paperclip"} />{" "}
                                  {comentario.nomeArquivo}
                                </small>
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    Quer deixar um recado interno (sua empresa) ou para o{" "}
                    {this.props.tipoContrato
                      ? this.props.tipoContrato
                      : "Terceiro / Tomador"}
                    ?
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr className="mb-5 mt-0" />
        <div className="row mx-0 d-flex align-items-center justify-content-center">
          <div className="col-12 px-4">
            <div className="card">
              <div className="card-body px-2">
                <Formik
                  initialValues={{
                    comentarioInterno: 1,
                    comentario: "",
                    arquivo: "",
                  }}
                  onSubmit={this.handleSubmit.bind(this)}
                  render={({
                    isSubmitting,
                    setFieldValue,
                    handleSubmit,
                    values,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label
                              htmlFor="comentario"
                              className="font-weight-bold h4"
                            >
                              <FontAwesomeIcon
                                style={{ color: "#f15923", fontSize: "2rem" }}
                                icon={["far", "comment-dots"]}
                              />{" "}
                              DEIXE SUA MENSAGEM
                            </label>
                            <Field
                              component="textarea"
                              rows="8"
                              placeholder="Digite aqui..."
                              id="comentario"
                              name="comentario"
                              className="form-control"
                              validate={requiredField}
                              disabled={this.state.lockedFields}
                            />
                            <ErrorMessage
                              name="comentario"
                              component="small"
                              className="form-text text-danger"
                            />
                          </div>
                        </div>
                      </div>
                      {this.isTomador() && (
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span
                                    className="input-group-text"
                                    id="comentarioArquivo"
                                  >
                                    Arquivo (PDF)
                                  </span>
                                </div>
                                <div className="custom-file">
                                  <input
                                    type="file"
                                    className="custom-file-input"
                                    id="arquivo"
                                    name="arquivo"
                                    accept="application/pdf"
                                    aria-describedby="comentarioArquivo"
                                    disabled={
                                      this.state.lockedFields || isSubmitting
                                    }
                                    onChange={(event) => {
                                      const arquivo = event.target.files[0];
                                      if (
                                        arquivo &&
                                        arquivo.type !== "application/pdf" &&
                                        arquivo.type !==
                                          "application/wps-office.pdf"
                                      ) {
                                        MySwal.fire({
                                          type: "error",
                                          title: "Selecione um arquivo PDF",
                                          toast: true,
                                          position: "center",
                                          showConfirmButton: false,
                                          timer: 2000,
                                        });
                                        return;
                                      }
                                      setFieldValue("arquivo", arquivo || "");
                                    }}
                                  />
                                  <label
                                    className="custom-file-label"
                                    htmlFor="arquivo"
                                  >
                                    {values.arquivo
                                      ? values.arquivo.name
                                      : "Escolher arquivo"}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row pt-4">
                        <label
                          className="font-weight-bold pl-2"
                          style={{ fontSize: "18px" }}
                        >
                          ENVIAR PARA:
                        </label>
                        <div className="col-12 d-flex align-items-center justify-content-center">
                          <ButtonWarning
                            onClick={() => {
                              setFieldValue("comentarioInterno", 1);
                            }}
                            type="submit"
                            disabled={isSubmitting}
                          >
                            <FontAwesomeIcon icon={"lock"} /> APENAS SUA EMPRESA
                          </ButtonWarning>
                          <ButtonSuccess
                            onClick={() => {
                              setFieldValue("comentarioInterno", 0);
                            }}
                            type="submit"
                            className="ml-3"
                            disabled={isSubmitting}
                          >
                            <FontAwesomeIcon icon={"globe-americas"} /> TODOS
                          </ButtonSuccess>
                        </div>
                      </div>
                    </Form>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
ComentarioForm.propTypes = {
  errors: PropTypes.object.isRequired,
  dados: PropTypes.any,
  comentarios: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  comentarios: state.comentarios.comentarios,
  total: state.comentarios.total - state.comentarios.comentarios?.length,
  errors: state.errors,
  dados: state.dados.data,
  loading: state.comentarios.loading,
});

export default connect(mapStateToProps)(withRouter(ComentarioForm));
